import {
  CUSTOMER_INFORMATION_PATH,
  HOME_PATH,
  PDP_PATH,
  PHYSICIAN_RESULT_PATH,
  SEARCH_PHYSICIAN_PATH,
  STORE_PATH,
} from '../../constants'

type SettingsRecord = Record<string, { displayAdornment: boolean }>

export class AnnouncementBannerController {
  private readonly pathname: string

  private readonly settings: SettingsRecord = {
    [HOME_PATH]: { displayAdornment: false },
    [STORE_PATH]: { displayAdornment: true },
    [PDP_PATH]: { displayAdornment: false },
    [CUSTOMER_INFORMATION_PATH]: { displayAdornment: false },
    [SEARCH_PHYSICIAN_PATH]: { displayAdornment: false },
    [PHYSICIAN_RESULT_PATH]: { displayAdornment: false },
  }

  constructor(pathname: string) {
    this.pathname = this.cleanPathname(pathname)
  }

  public get shouldDisplayBanner(): boolean {
    // If the pathname is not in the settings, we don't want to display the banner
    return !!this.settingFromPathname(this.pathname)
  }

  public get shouldDisplayAdornment(): boolean {
    const setting = this.settingFromPathname(this.pathname)
    return this.shouldDisplayBanner && setting?.displayAdornment
  }

  public get isHomePage(): boolean {
    return this.pathname === HOME_PATH
  }

  private settingFromPathname(pathname: string) {
    return this.settings[pathname]
  }

  private cleanPathname(pathname: string) {
    // Check if the path is from the PDP since it has a dynamic part
    if (pathname.startsWith('/health/gp/')) {
      return PDP_PATH
    }

    return pathname
  }
}
